/**
 * @Author: Lihao sun sunlihao.cosmo@haier.com
 * @Date: 2024-12-19 09:59:56
 * @LastEditors: Lihao sun sunlihao.cosmo@haier.com
 * @LastEditTime: 2024-12-19 16:04:43
 * @FilePath: src/router/constantRoutes.js
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */
/**
 * @Author 22030124/xieyq
 * @Date 2023-11-15 14:36:14
 * @Description 路由配置js
 */
// import Layout from '@/views/index/index.vue'
const NoPermission = () => import('@/views/warning/index.vue')
const AiChat = () => import('@/views/aiChat/index.vue')
// import EiipProducts from '@/views/EiipProducts/index.vue'
// 门户组件
const Dashboard = () => import('@/views/portal/index.vue')

const PbcDetail = () => import('@/views/pbcDetail/index.vue')
const About = () => import('@/views/about/index.vue')
const NotFound = () => import('@/views/warning/404.vue')
// 搜索页面
const SearchPage = () => import('@/views/search/index.vue')
// 个人中心页面
const Profile = () => import('@/views/profile/index.vue')
import manageRoutes from './modules/manager'
import workbenchRoutes from './modules/workbench'

import adminRoutes from './modules/admin'
import basicServiceRoutes from './modules/basicService'
import backupServiceRoutes from './modules/backupService'
import applicationRoutes from './modules/application'
import digitalHumanRoutes from './modules/digitalHuman'
// 布局
// const layout = () => import('@/views/index/index.vue')
// 菜单布局
// const menuLayout = () => import('@/components/layout/index.vue')
export default [
  {
    path: '/enterprise-onboarding',
    name: 'EnterpriseOnboarding',
    component: () => import('@/views/enterprise-onboarding/index.vue'),
    meta: {
      title: '完善企业信息',
      canAccess: true
    }
  },
  {
    path: '/sphere-intro',
    name: 'SphereIntro',
    component: () => import('@/views/digital-intro/index.vue'),
    meta: {
      title: '数字人介绍',
      canAccess: true
    }
  },
  {
    path: '/dashboard',
    // 旧版桌面端嵌入工作台入口：功能已全部切换到新版 /smart-engine，保留 desk.vue 源码但重定向到新版
    component: () => import('@/views/smart-workbench/desk.vue'),
    redirect: (to) => ({ path: '/smart-engine', query: to.query }),
    meta: {
      name: '主应用',
      context: '',
      type: 'INNER_APP',
      canAccess: true
    }
  },
  // 布局
  {
    path: '/',
    // 组件
    // component: Layout,
    component: () => import('@/views/index/index.vue'),
    children: [
      {
        path: '',
        component: Dashboard,
        meta: {
          name: '主应用',
          context: '',
          type: 'INNER_APP',
          canAccess: true
        }
        // component: () => import('@/views/portal/index.vue')
      },
      {
        path: 'chatAi/:id',
        component: AiChat,
        meta: {
          name: '主应用',
          context: '',
          type: 'INNER_APP',
          canAccess: true
        }
      },
      // {
      //   path: 'eiipProducts',
      //   component: EiipProducts,
      //   meta: {
      //     name: '企工平台产品系列',
      //     context: '',
      //     type: 'INNER_APP',
      //     canAccess: true
      //   }
      // },
      {
        path: 'pbc/detail',
        component: PbcDetail,
        meta: {
          name: '主应用',
          context: '',
          type: 'INNER_APP',
          canAccess: true
        }
        // component: () => import('@/views/portal/index.vue')
      },
      {
        path: 'search',
        name: 'Search',
        component: SearchPage,
        meta: {
          name: '主应用',
          context: '',
          type: 'INNER_APP',
          canAccess: true
        }
      },
      // 关于页面
      {
        path: 'about',
        name: 'About',
        component: About,
        meta: {
          name: '主应用',
          context: '',
          type: 'INNER_APP',
          canAccess: true
        }
      },
      // 个人中心页面
      {
        path: 'profile',
        name: 'Profile',
        component: Profile,
        meta: {
          name: '主应用',
          context: '',
          type: 'INNER_APP',
          canAccess: true
        },
        children: [
          {
            path: 'config',
            name: 'ProfileConfig',
            component: Profile,
            meta: {
              name: '个人配置',
              type: 'INNER_APP',
              canAccess: true
            }
          },
          {
            path: 'password',
            name: 'ProfilePassword',
            component: Profile,
            meta: {
              name: '密码设置',
              type: 'INNER_APP',
              canAccess: true
            }
          },
          {
            path: 'accountSecurity',
            name: 'ProfileAccountSecurity',
            component: Profile,
            meta: {
              name: '账号安全',
              type: 'INNER_APP',
              canAccess: true
            }
          },
          {
            path: 'socials',
            name: 'ProfileSocials',
            component: Profile,
            meta: {
              name: '社交关联',
              type: 'INNER_APP',
              canAccess: true
            }
          },
          {
            path: 'timebased',
            name: 'ProfileTimebased',
            component: Profile,
            meta: {
              name: '双因素认证',
              type: 'INNER_APP',
              canAccess: true
            }
          },
          {
            path: 'sessions',
            name: 'ProfileSessions',
            component: Profile,
            meta: {
              name: '会话管理',
              type: 'INNER_APP',
              canAccess: true
            }
          },
          {
            path: 'audit',
            name: 'ProfileAudit',
            component: Profile,
            meta: {
              name: '审计',
              type: 'INNER_APP',
              canAccess: true
            },
            children: [
              {
                path: 'logins',
                name: 'ProfileAuditLogins',
                component: Profile,
                meta: {
                  name: '登录审计',
                  type: 'INNER_APP',
                  canAccess: true
                }
              },
              {
                path: 'login-apps',
                name: 'ProfileAuditLoginApps',
                component: Profile,
                meta: {
                  name: '应用登录审计',
                  type: 'INNER_APP',
                  canAccess: true
                }
              }
            ]
          }
        ]
      },
      {
        path: 'smart-engine',
        component: () => import('@/views/smart-engine-new/index.vue'),
        meta: {
          name: '智能引擎',
          type: 'INNER_APP',
          canAccess: true
        },
        // 路由 ↔ agent 双向绑定：子路由 meta.agentName 声明绑定的数字人/智能体，
        // 与 smart-engine-new/mixins/workspaceConstants.js 的 AGENT_ROUTE_BINDINGS 保持一致
        children: [
          { path: '', redirect: { name: 'SmartEngineChat' }},
          { path: 'workbench/ceo', name: 'ceoWorkbench', component: () => import('@/views/workbench-new/ceo/index.vue'), meta: {
            agentName: 'ceo_shu_zi_ren',
            name: '驾驶舱',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'workbench/cfo', name: 'cfoWorkbench', component: () => import('@/views/workbench-new/cfo/index.vue'), meta: {
            agentName: 'cai_wu_shu_zi_ren',
            name: '驾驶舱',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'workbench/cso', name: 'csoWorkbench', component: () => import('@/views/workbench-new/cso/index.vue'), meta: {
            agentName: 'gong_ying_lian_shu_zi_ren',
            name: '驾驶舱',
            type: 'INNER_APP',
            canAccess: true
          }},
          // 能源站长数字人驾驶舱：复制 CEO 驾驶舱页面，仅标题与 agentName 绑定不同（tags 含 NY-DH）
          { path: 'workbench/energy', name: 'energyWorkbench', component: () => import('@/views/workbench-new/energy/index.vue'), meta: {
            agentName: 'dh_ny_dh',
            name: '驾驶舱',
            type: 'INNER_APP',
            canAccess: true
          }},
          // 统一驾驶舱：所有数字人共用，按 query.agentId 对应数字人绑定的 workbenchId 回显配置
          { path: 'workbench/unified', name: 'unifiedWorkbench', component: () => import('@/views/workbench-new/unified/index.vue'), meta: {
            name: '驾驶舱',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'agent/indicator', name: 'SmartEngineAgentIndicator', component: () => import('@/views/smart-engine-new/components/AgentIndicator.vue'), meta: {
            agentName: 'zhi_biao_ding_yi_zhi_neng_ti',
            name: '指标定义智能体',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'agent/governance', name: 'SmartEngineAgentGovernance', component: () => import('@/views/smart-engine-new/components/AgentGovernance.vue'), meta: {
            agentName: 'ben_ti_zhi_li_zhi_neng_ti',
            name: '本体治理智能体',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'agent/decision', name: 'SmartEngineAgentDecision', component: () => import('@/views/smart-engine-new/components/AgentDecision.vue'), meta: {
            agentName: 'jing_ying_jue_ce_zhi_neng_ti',
            name: '经营决策智能体',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'agent-module/:module', name: 'SmartEngineAgentModule', component: () => import('@/views/smart-engine-new/components/AgentModulePage.vue'), meta: {
            name: '智能体模块',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'chat', name: 'SmartEngineChat', component: () => import('@/views/smart-engine-new/components/SessionChatPage.vue'), meta: {
            name: '会话',
            type: 'INNER_APP',
            canAccess: true,
            sessionPage: true
          }},
          { path: 'intro', name: 'SmartEngineIntro', component: () => import('@/views/digitalHuman/intro.vue'), meta: {
            name: '数字人介绍',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'plaza/digital', name: 'SmartEngineDigitalPlaza', component: () => import('@/views/smart-engine-new/components/DigitalPlazaPage.vue'), meta: {
            name: '数字人广场',
            type: 'INNER_APP',
            canAccess: true
          }},
          // 关键指标页面
          {
            path: 'renDanHeYi',
            name: 'RenDanHeYi',
            component: () => import('@/views/smart-engine-new/agents/RenDanHeYi.vue'),
            meta: {
              name: '关键目标',
              type: 'INNER_APP',
              canAccess: true
            }
          },
          {
            path: 'digital-profile',
            name: 'SmartEngineDigitalProfile',
            component: () => import('@/views/smart-engine-new/components/DigitalHumanProfile.vue'),
            meta: {
              name: '数字人档案',
              type: 'INNER_APP',
              canAccess: true
            }
          },
          { path: 'plaza/agent', name: 'SmartEngineAgentPlaza', component: () => import('@/views/smart-engine-new/components/AgentPlazaPage.vue'), meta: {
            name: '智能体广场',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'knowledge_base', name: 'SmartEngineKnowledgeBase', component: () => import('@/views/smart-engine-new/components/IframePage.vue'), meta: {
            name: '知识库',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'detail/:id', name: 'SmartEngineDetail', component: () => import('@/views/workbench-new/components/EnterpriseDetail.vue'), props: true, meta: {
            name: '报告详情',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'businessAnalysis', name: 'BusinessAnalysis', component: () => import('@/views/workbench-new/components/EnterpriseListNew.vue'), props: (route) => ({ agentId: route.query.agentId || '' }), meta: {
            name: '经营分析',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'marketInsight', name: 'MarketInsight', component: () => import('@/views/workbench-new/components/EnterpriseListNew.vue'), props: (route) => ({ agentId: route.query.agentId || '' }), meta: {
            name: '市场洞察',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'list', name: 'SmartEngineList', component: () => import('@/views/workbench-new/components/EnterpriseList.vue'), props: (route) => ({ agentId: route.query.agentId || '' }), meta: {
            name: '战情室报告',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'task-detail/:id', name: 'SmartEngineTaskDetail', component: () => import('@/views/workbench-new/components/TaskDetail.vue'), props: true, meta: {
            name: '任务详情',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'task-list', name: 'SmartEngineTaskList', component: () => import('@/views/workbench-new/components/TaskList.vue'), props: (route) => ({ agentId: route.query.agentId || '' }), meta: {
            name: '自动化',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'schedule', name: 'BusinessSchedule', component: () => import('@/views/smart-engine-new/components/BusinessSchedule.vue'), props: (route) => ({ agentId: route.query.agentId || '' }), meta: {
            name: '商务日程',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'history-report/:id', name: 'SmartEngineHistoryReport', component: () => import('@/views/workbench-new/components/HistoryReportDetail.vue'), meta: {
            name: '历史报告详情',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'meeting-report', name: 'SmartEngineMeetingReport', component: () => import('@/views/smart-engine-new/components/MeetingReportDetail.vue'), meta: {
            name: '会前材料报告',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'decision-detail/:id', name: 'SmartEngineDecisionDetail', component: () => import('@/views/workbench-new/components/DecisionDetail.vue'), props: true, meta: {
            name: '决策详情',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'decision-list', name: 'SmartEngineDecisionList', component: () => import('@/views/workbench-new/components/DecisionList.vue'), props: (route) => ({ reviewerAgentId: route.query.reviewerAgentId || '' }), meta: {
            name: '决策列表',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'tool/:toolId', name: 'SmartEngineTool', component: () => import('@/views/workbench-new/cfo/tools/CfoToolPanel.vue'), meta: {
            name: '智能引擎工具',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'report/:reportType', name: 'SmartEngineReport', component: () => import('@/views/smart-engine-new/components/ReportPage.vue'), props: true, meta: {
            name: '经营报表详情',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'price-management', name: 'SmartEnginePriceManagement', component: () => import('@/views/workbench-new/cso/PriceIncreaseManagement.vue'), meta: {
            name: '智能引擎价格管理',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'preference', name: 'SmartEnginePreference', component: () => import('@/views/smart-workbench/components/SupplyChainPreference.vue'), meta: {
            name: '智能引擎偏好',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'e2e-report', name: 'SmartEngineE2eReport', component: () => import('@/views/smart-engine-new/components/E2ePlStatementPage.vue'), meta: {
            name: 'E2E损益表',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'cfo-report', name: 'SmartEngineCfoReport', component: () => import('@/views/smart-engine-new/components/CfoReportPage.vue'), meta: {
            name: 'CEO专项报告',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'process-files', name: 'SmartEngineProcessFiles', component: () => import('@/views/smart-engine-new/components/ProcessFileManage.vue'), props: (route) => ({ agentId: route.query.agentId || '' }), meta: {
            name: '过程文件管理',
            type: 'INNER_APP',
            canAccess: true
          }},
          // 销售数字人：iframe 嵌入 https://sales-digital-human.cosmoplat.net
          { path: 'sale/workbench', name: 'SaleWorkbench', component: () => import('@/views/workbench-new/sale/workbench.vue'), meta: {
            name: '驾驶舱',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'sale/opportunity', name: 'SaleOpportunity', component: () => import('@/views/workbench-new/sale/opportunity.vue'), meta: {
            name: '商机报价',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'sale/bidding', name: 'SaleBidding', component: () => import('@/views/workbench-new/sale/bidding.vue'), meta: {
            name: '投标作战',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'sale/contract', name: 'SaleContract', component: () => import('@/views/workbench-new/sale/contract.vue'), meta: {
            name: '合同智控',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'sale/deliver', name: 'SaleDeliver', component: () => import('@/views/workbench-new/sale/deliver.vue'), meta: {
            name: '履约交付',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'sale/customer', name: 'SaleCustomer', component: () => import('@/views/workbench-new/sale/customer.vue'), meta: {
            name: '客户洞察',
            type: 'INNER_APP',
            canAccess: true
          }},
          // 需求与计划智能体：挂载「智能应用」菜单下，完整还原原型（mode=agent）
          { path: 'supply-planning', name: 'SupplyDemandPlanning', component: () => import('@/views/workbench-new/components/SupplyDemandPlanning.vue'), props: (route) => ({ agentId: route.query.agentId || '', mode: 'agent' }), meta: {
            name: '需求与计划',
            type: 'INNER_APP',
            canAccess: true
          }},
          // 供应商管控智能体：挂载「智能应用」菜单下，完整还原原型（mode=agent）
          { path: 'supplier-management', name: 'SupplierManagement', component: () => import('@/views/workbench-new/components/SupplierManagement.vue'), props: (route) => ({ agentId: route.query.agentId || '', mode: 'agent' }), meta: {
            name: '供应商管控',
            type: 'INNER_APP',
            canAccess: true
          }},
          // 合同履约智能体：挂载「智能应用」菜单下，完整还原原型（mode=agent）
          { path: 'contract-fulfillment', name: 'ContractFulfillment', component: () => import('@/views/workbench-new/components/ContractFulfillment.vue'), props: (route) => ({ agentId: route.query.agentId || '', mode: 'agent' }), meta: {
            name: '合同履约',
            type: 'INNER_APP',
            canAccess: true
          }},
          // 智能决策智能体：挂载「智能应用」菜单下，完整还原原型（mode=agent）
          { path: 'data-analysis', name: 'DataAnalysis', component: () => import('@/views/workbench-new/components/DataAnalysis.vue'), props: (route) => ({ agentId: route.query.agentId || '', mode: 'agent' }), meta: {
            name: '智能决策',
            type: 'INNER_APP',
            canAccess: true
          }},
          // 采购数字人：iframe 嵌入 https://mxx-cgszr.cosmoplat.net
          { path: 'caigou/dashboard', name: 'CaigouDashboard', component: () => import('@/views/workbench-new/caigou/dashboard.vue'), meta: {
            name: '驾驶舱',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'caigou/assistant', name: 'CaigouAssistant', component: () => import('@/views/workbench-new/caigou/assistant.vue'), meta: {
            name: '需求与计划',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'caigou/management', name: 'CaigouManagement', component: () => import('@/views/workbench-new/caigou/management.vue'), meta: {
            name: '供应商管控',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'caigou/contract', name: 'CaigouContract', component: () => import('@/views/workbench-new/caigou/contract.vue'), meta: {
            name: '合同履约',
            type: 'INNER_APP',
            canAccess: true
          }},
          { path: 'caigou/analysis', name: 'CaigouAnalysis', component: () => import('@/views/workbench-new/caigou/analysis.vue'), meta: {
            name: '智能决策',
            type: 'INNER_APP',
            canAccess: true
          }}
        ]
      }

    ]
  },
  {
    path: '/noPermission',
    // component: Layout,
    component: () => import('@/views/index/index.vue'),
    children: [
      {
        path: '/noPermission',
        component: NoPermission
      }
    ]
  },
  // 找不到该页面
  {
    path: '/404',
    // component: Layout,
    component: () => import('@/views/index/index.vue'),
    children: [
      {
        path: '/404',
        component: NotFound
      }
    ]
  },
  // COSMO Sphere 产品介绍落地页（无需登录、无布局）

  manageRoutes,
  adminRoutes,
  basicServiceRoutes,
  backupServiceRoutes,
  applicationRoutes,
  digitalHumanRoutes,
  workbenchRoutes
]
